<template>
  <section class="hebView">
    <!-- <div class="fioriture"></div>
    <h2>Nos hébergements</h2>
    <div class="fioriture"></div>-->
    <h2 class="titlePage">
      <strong>_</strong>
      Notre Gîte
      <strong>_</strong>
    </h2>

    <p>
      Découvrez notre gîte familial spacieux de 140 m² à Touget, avec 4 chambres doubles et un grand dortoir,
      <br> cuisine équipée (four, lave-vaisselle), salon cheminée et grande terrasse couverte / ombragée. <br>
      Équipements : piscine sécurisée, WiFi gratuit, jardin 3000 m², parking.
    </p>

    <article class="hebItem">
      <transition name="fade" appear>
        <img src="@/assets/images/grandgite/P1070847.jpg" alt="le gîte - gîte en Lebé" />
      </transition>

      <div class="absoInfos wow leftToRight">
        <h3>Bienvenue</h3>
        <p>
          A votre arrivée, un parking privatif vous est réservé, fleuri et ombragé. Il vous conduit directement à cette belle bâtisse, située au cœur de
          notre exploitation agricole bio. Elle permet une capacité de couchage pour 6 ou 15 personnes. De grand confort, elle répondra à vos
          attentes grâce aux prestations que nous mettons à disposition.
        </p>

        <router-link to="nos-hebergements/le-gite" class="greenBtn">Voir plus d'infos</router-link>
      </div>
    </article>

    <Slideshow sliderheight="450px" :slidewidth="responsiveWidth" rightnav_class="fas fa-angle-right fa-4x"
      leftnav_class="fas fa-angle-left fa-4x" activeclass="activeDiapo">
      <div>
        <img src="@/assets/images/001.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/002.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/003.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/004.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/005.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/006.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/007.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/008.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/009.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/010.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/011.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/013.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/014.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/015.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/016.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/017.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/018.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/019.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/020.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/021.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/022.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/023.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/025.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/026.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/027.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/031.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/032.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/033.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/034.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/035.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/037.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/038.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/042.jpg" alt="Gite d'en lebé" />
      </div>
    </Slideshow>

    <!-- <article class="hebItem reverseHebItem" id="secondHeb">
      <div class="absoInfos absoInfosLeft wow rightToLeft">
        <h3>L'escale</h3>

        <p>
          Idéal pour un couple, vous êtes complètement autonomes puisqu’il est parfaitement équipé pour cuisiner,
          se reposer, et partir à la découverte des jolis villages voisins, profiter des marchés, arpenter les chemins de randonnée….
          Il y en a pour tous les goûts ! Nous pourrons vous conseiller.
        </p>

        <router-link to="nos-hebergements/studio" class="greenBtn">Voir plus d'infos</router-link>
      </div>

      <transition name="fade" appear>
        <img src="@/assets/images/Studio/Studio A.jpg" alt="le studio - gite en lebé" />
      </transition>
    </article> -->

    <!-- <article class="hebItem">
      <transition name="fade" appear>
        <img src="@/assets/images/Chambredhote/07.jpg" alt="les chambres d'hotes - gite en lebé" />
      </transition>

      <div class="absoInfos wow leftToRight">
        <h3>
          Les chambres
          <br />d'hôtes
        </h3>
        <p>
          Nos trois chambres d’hôtes vous offrent des
          prestations de qualité : une literie confortable, des sanitaires privatifs, une télévision et un accès wifi…
          avec en prime un petit déjeuner gourmand « fait maison ».
        </p>

        <router-link to="nos-hebergements/chambres-d-hotes" class="greenBtn">Voir plus d'infos</router-link>
      </div>
    </article> -->
    <GreenBarContact></GreenBarContact>
  </section>
</template>

<script>
import WOW from "@/assets/wow.min.js";
import GreenBarContact from "@/components/GreenBarContact.vue";
import Slideshow from "@/components/Slideshow.vue";

export default {
  name: "Hebergements",
  data: function () {
    return {
      itemsList: null,
      lastScroll: 0,
      currentView: 0,
      observer: null,
    };
  },
  setup() {},
  created() {
    new WOW(
      { mobile: false } // default
    ).init();
  },
  components: {
    GreenBarContact,
    Slideshow
  },

  computed: {
    responsiveWidth: {
      get() {
        let val = window.innerWidth;
        if (val > 1000) {
          return "25";
        } else if (val < 1000 && val > 768) {
          return "50";
        } else return "90";
      },
    },
  },

  mounted() {},

  beforeDestroy() {},
  methods: {},
};
</script>
<style>
.hebView {
  text-align: center;
}
.hebView .fioriture {
  height: 70px;
}
.hebView > h2 {
  color: var(--dark-color);
  font-size: 3.5rem;
  margin: 0 0 2rem;
  font-weight: 100;
}
.hebView > p {
  letter-spacing: 0.5px;
  margin-bottom: 3rem;
  font-size: 1.1rem;
}

.presentationItem {
  height: 80vh;
  background: tomato;
}
.barBottom {
  position: relative;
  height: 160px;
}
.barBottom .navImg {
  background: rgba(168, 190, 80, 1);
}
@media all and (max-width: 1000px) {
  .hebItem {
    flex-direction: column;
    width: 100vw;
    border-bottom: 0;
    border-top: 0;
    height: auto;
    margin-bottom: 1rem;
  }
  .hebItem > img {
    width: 100%;
    height: 60vh;
    object-fit: cover;
  }
  .reverseHebItem img {
    margin-left: 0;
  }
  .absoInfos > * {
    margin: 0 2%;
  }
  .greenBtn {
    padding: 0.5rem 1.5rem;
    float: right;
    margin: 1%;
  }
  .reverseHebItem .absoInfosLeft .greenBtn {
    margin-left: 5%;
  }
  .absoInfos .greenBtn {
    margin-left: 5%;
  }
  .absoInfosLeft {
    text-align: left;
  }
  .absoInfos {
    position: relative;
    transform: translateY(0);
    width: 100%;
    border-bottom: 4px solid var(--dark-color);
    padding-bottom: 4px;
    top: unset;
  }

  .reverseHebItem {
    flex-direction: column-reverse;
  }
  .absoInfos h3 {
    margin-bottom: 0;
    width: auto;
    padding: 8px;
    margin-left: 5%;
  }
  .absoInfos p {
    padding: 8px;
    margin-left: 5%;
    width: 90%;
  }
}
@media all and (max-width: 500px) {
  .hebView > h2 {
    font-size: 10vw;
  }

  .hebView p:not(.important) {
    display: none;
  }
  .absoInfos h3 {
    font-size: 10vw;
  }
  .barBottom {
    display: none;
  }
}
</style>